import { render, staticRenderFns } from "./MediaSettingsFields.vue?vue&type=template&id=60874191&scoped=true&"
import script from "./MediaSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./MediaSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./MediaSettingsFields.vue?vue&type=style&index=0&id=60874191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60874191",
  null
  
)

export default component.exports